import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["skipFilter", "isLight"],
    _excluded2 = ["agent"];

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import runQueryInit from './dataSimpleRest';
import get from '../utils/get';
import uniqBy from '../utils/uniqBy';
import isEmpty from '../utils/isEmpty';
import EncryptionService from './encryption';
import { mapSEOandGovernmentLocalities } from '../utils/seoLocalities';
var MINIMUM_ADDRESS_ACCURACY = 0.5;

// @ts-ignore
var searchLocality = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _ref2,
        q,
        regionDepartmentDb,
        res,
        keyWeight,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref2 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, q = _ref2.q;
          _context.next = 3;
          return import('../utils/regionDepartment');

        case 3:
          regionDepartmentDb = _context.sent.default;
          res = regionDepartmentDb.search({
            $or: [{
              $and: [{
                type: '=REGION',
                name: q
              }]
            }, {
              $and: [{
                type: '=REGION',
                shortName: q
              }]
            }, {
              $and: [{
                type: '=DEPARTMENT',
                code: "=".concat(q)
              }]
            }, {
              $and: [{
                type: '=DEPARTMENT',
                name: q
              }]
            }, {
              $and: [{
                type: '=DEPARTMENT',
                shortName: q
              }]
            }]
          }, {
            limit: 5
          }).filter(function (_ref3) {
            var x = _ref3.item;
            return (// @ts-ignore
              "".concat(x.shortName, "_").concat(x.type).toUpperCase() !== 'PARIS_DEPARTMENT'
            );
          } // Hidden Paris department JIRA:MPAT-2165
          );
          keyWeight = regionDepartmentDb._keyStore.get('type').weight;
          res.forEach(function (item) {
            // We dont want include the part of type in calcute score, so we recalcute this
            // score = 1*(part_1_score**part_1_weight)*(part_2_score**part_2_weight)....(part_n_score**part_n_weight)
            // we only need score of another part (not type), so the result will be
            // part_2_score = (score/(part_1_score**part_1_weight))**(1/part_2_weight)
            // eslint-disable-next-line no-param-reassign
            item.score = Math.pow(item.score / Math.pow(Number.EPSILON, keyWeight), 1 / keyWeight);
          });
          return _context.abrupt("return", {
            data: {
              features: res.map(function (_ref4) {
                var item = _ref4.item,
                    score = _ref4.score;
                return _objectSpread(_objectSpread({}, item), {}, {
                  properties: _objectSpread(_objectSpread({}, item), {}, {
                    score: 1 - score,
                    id: "".concat(item.code, "-").concat(item.shortName),
                    city: item.name,
                    label: item.name,
                    type: item.type.toLowerCase(),
                    postcode: item.code
                  })
                });
              })
            }
          });

        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function searchLocality() {
    return _ref.apply(this, arguments);
  };
}();

var Rest = /*#__PURE__*/_createClass(function Rest(endpoints) {
  var _this = this;

  var httpOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var storage = arguments.length > 2 ? arguments[2] : undefined;
  var EncryptionModule = arguments.length > 3 ? arguments[3] : undefined;

  _classCallCheck(this, Rest);

  _defineProperty(this, "crudActions", /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref5) {
      var type, scope, chunkUrlResource, _ref5$payload, payload, chunkId, chunkResource, signal, version, prefix, res;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            type = _ref5.type, scope = _ref5.scope, chunkUrlResource = _ref5.chunkUrlResource, _ref5$payload = _ref5.payload, payload = _ref5$payload === void 0 ? {} : _ref5$payload, chunkId = _ref5.chunkId, chunkResource = _ref5.chunkResource, signal = _ref5.signal, version = _ref5.version;
            prefix = scope !== null && scope !== void 0 ? scope : _this.endpoints.defaultApiScope;
            _context2.next = 4;
            return _this.runQueryCrud(type, "".concat(prefix, "/").concat(chunkUrlResource), payload, chunkId, chunkResource, signal, version, prefix);

          case 4:
            res = _context2.sent;
            return _context2.abrupt("return", res);

          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));

    return function (_x) {
      return _ref6.apply(this, arguments);
    };
  }());

  _defineProperty(this, "authActions", /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(action) {
      var _action$payload, payload, type, res;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _action$payload = action.payload, payload = _action$payload === void 0 ? {} : _action$payload, type = action.type;
            _context3.next = 3;
            return _this.runQueryAuth('AUTH', type.toLowerCase(), {
              data: payload,
              token: payload.token,
              refresh: payload.refresh
            });

          case 3:
            res = _context3.sent;
            return _context3.abrupt("return", res.data);

          case 5:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));

    return function (_x2) {
      return _ref7.apply(this, arguments);
    };
  }());

  _defineProperty(this, "getCurrentUserAction", /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref8) {
      var resource, payload, res;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            resource = _ref8.resource, payload = _ref8.payload;
            _context4.next = 3;
            return _this.runQueryCrud('GET_ONE', "".concat(_this.endpoints.defaultApiScope, "/").concat(resource), payload);

          case 3:
            res = _context4.sent;
            return _context4.abrupt("return", res.data);

          case 5:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));

    return function (_x3) {
      return _ref9.apply(this, arguments);
    };
  }());

  _defineProperty(this, "addressActions", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    var endpoint,
        _ref11,
        type,
        resource,
        _ref11$payload,
        payload,
        signal,
        types,
        results,
        rv,
        cityCodes,
        lapostePromise,
        resPromise,
        _yield$Promise$all3,
        _yield$Promise$all4,
        laposte,
        res,
        lapostePostalCodeByCityCode,
        resByCityCode,
        _iterator,
        _step,
        _loop,
        _args7 = arguments;

    return _regeneratorRuntime.wrap(function _callee6$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          endpoint = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : _this.endpoints.address;
          _ref11 = _args7.length > 1 ? _args7[1] : undefined, type = _ref11.type, resource = _ref11.resource, _ref11$payload = _ref11.payload, payload = _ref11$payload === void 0 ? {} : _ref11$payload, signal = _ref11.signal;

          if (payload.q) {
            _context7.next = 4;
            break;
          }

          return _context7.abrupt("return", {
            data: []
          });

        case 4:
          types = [];

          if (Array.isArray(payload.type)) {
            types = types.concat(payload.type);
          } else {
            types.push(payload.type || '');
          }

          _context7.next = 8;
          return Promise.all(types.map( /*#__PURE__*/function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(searchType) {
              var skipFilter, isLight, newPayload, res;
              return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) switch (_context5.prev = _context5.next) {
                  case 0:
                    skipFilter = payload.skipFilter, isLight = payload.isLight, newPayload = _objectWithoutProperties(payload, _excluded);

                    if (!(searchType === 'region+department')) {
                      _context5.next = 7;
                      break;
                    }

                    _context5.next = 4;
                    return searchLocality(_objectSpread({}, payload));

                  case 4:
                    res = _context5.sent;
                    _context5.next = 10;
                    break;

                  case 7:
                    _context5.next = 9;
                    return runQueryInit(endpoint, _this.httpOptions)(type, resource, _objectSpread(_objectSpread({}, newPayload), {}, {
                      type: searchType
                    }), null, null, signal);

                  case 9:
                    res = _context5.sent;

                  case 10:
                    return _context5.abrupt("return", {
                      size: res.data.features.length,
                      data: res.data
                    });

                  case 11:
                  case "end":
                    return _context5.stop();
                }
              }, _callee5);
            }));

            return function (_x4) {
              return _ref12.apply(this, arguments);
            };
          }()));

        case 8:
          results = _context7.sent;
          rv = results.reduce(function (result, _ref13) {
            var data = _ref13.data;
            return result.concat(data.features.filter(function (feature) {
              return payload.skipFilter || feature.properties.score > MINIMUM_ADDRESS_ACCURACY;
            }));
          }, []);
          rv = {
            data: uniqBy(rv, 'properties.id').sort(function (a, b) {
              var aIsLast = a.properties.type.toLowerCase() === 'region' || a.properties.type.toLowerCase() === 'department';
              var bIsLast = b.properties.type.toLowerCase() === 'region' || b.properties.type.toLowerCase() === 'department';
              if (aIsLast) return 1;
              if (bIsLast) return -1;
              return b.properties.score - a.properties.score;
            })
          };

          if (!payload.isLight) {
            _context7.next = 13;
            break;
          }

          return _context7.abrupt("return", rv);

        case 13:
          cityCodes = rv.data.filter(function (f) {
            var _f$properties;

            return (f === null || f === void 0 || (_f$properties = f.properties) === null || _f$properties === void 0 ? void 0 : _f$properties.type) === 'municipality';
          }).map(function (f) {
            return f.properties.citycode;
          });

          if (!(cityCodes.length > 0)) {
            _context7.next = 41;
            break;
          }

          lapostePromise = import('../utils/laposte_hexasmal.processed');
          resPromise = _this.runQueryCrud('GET_LIST', 'pat-public/localities', {
            cityCodes: cityCodes
          });
          _context7.next = 19;
          return Promise.all([lapostePromise, resPromise]);

        case 19:
          _yield$Promise$all3 = _context7.sent;
          _yield$Promise$all4 = _slicedToArray(_yield$Promise$all3, 2);
          laposte = _yield$Promise$all4[0];
          res = _yield$Promise$all4[1];
          lapostePostalCodeByCityCode = laposte.default;
          resByCityCode = res.data.items.reduce(function (curr, city) {
            return _objectSpread(_objectSpread({}, curr), {}, _defineProperty({}, city.code, city));
          }, {});
          _iterator = _createForOfIteratorHelper(rv.data);
          _context7.prev = 26;
          _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
            var _item$properties;

            var item, _item$properties3, citycode, city, cityPostCodes;

            return _regeneratorRuntime.wrap(function _loop$(_context6) {
              while (1) switch (_context6.prev = _context6.next) {
                case 0:
                  item = _step.value;

                  if ((item === null || item === void 0 || (_item$properties = item.properties) === null || _item$properties === void 0 ? void 0 : _item$properties.type) === 'municipality') {
                    _item$properties3 = item === null || item === void 0 ? void 0 : item.properties, citycode = _item$properties3.citycode;
                    city = resByCityCode === null || resByCityCode === void 0 ? void 0 : resByCityCode[citycode];

                    if (lapostePostalCodeByCityCode !== null && lapostePostalCodeByCityCode !== void 0 && lapostePostalCodeByCityCode[citycode]) {
                      item.properties.postcode = lapostePostalCodeByCityCode[citycode];
                    } else if ((city === null || city === void 0 ? void 0 : city.postCodes.length) > 1) {
                      cityPostCodes = city === null || city === void 0 ? void 0 : city.postCodes.filter(function (code) {
                        return code.toString().startsWith((city === null || city === void 0 ? void 0 : city.departmentCode) || '');
                      }); // eslint-disable-next-line prefer-destructuring

                      item.properties.postcode = (!isEmpty(cityPostCodes) ? cityPostCodes : city.postCodes).sort(function (a, b) {
                        return parseInt(a, 10) - parseInt(b, 10);
                      })[0];
                    }

                    item.properties.shortName = city === null || city === void 0 ? void 0 : city.shortName;
                  }

                case 2:
                case "end":
                  return _context6.stop();
              }
            }, _loop);
          });

          _iterator.s();

        case 29:
          if ((_step = _iterator.n()).done) {
            _context7.next = 33;
            break;
          }

          return _context7.delegateYield(_loop(), "t0", 31);

        case 31:
          _context7.next = 29;
          break;

        case 33:
          _context7.next = 38;
          break;

        case 35:
          _context7.prev = 35;
          _context7.t1 = _context7["catch"](26);

          _iterator.e(_context7.t1);

        case 38:
          _context7.prev = 38;

          _iterator.f();

          return _context7.finish(38);

        case 41:
          return _context7.abrupt("return", _objectSpread(_objectSpread({}, rv), {}, {
            data: rv.data.map(function (feature) {
              var _feature$properties, _feature$properties2;

              var _mapSEOandGovernmentL = mapSEOandGovernmentLocalities("".concat(feature === null || feature === void 0 || (_feature$properties = feature.properties) === null || _feature$properties === void 0 ? void 0 : _feature$properties.postcode, "-").concat(feature === null || feature === void 0 || (_feature$properties2 = feature.properties) === null || _feature$properties2 === void 0 ? void 0 : _feature$properties2.shortName)),
                  _mapSEOandGovernmentL2 = _slicedToArray(_mapSEOandGovernmentL, 2),
                  seoPostcode = _mapSEOandGovernmentL2[0],
                  apiGouvPostcode = _mapSEOandGovernmentL2[1];

              if (seoPostcode !== apiGouvPostcode) {
                var _seoPostcode$split;

                return _objectSpread(_objectSpread({}, feature), {}, {
                  properties: _objectSpread(_objectSpread({}, feature.properties), {}, {
                    postcode: seoPostcode === null || seoPostcode === void 0 || (_seoPostcode$split = seoPostcode.split('-')) === null || _seoPostcode$split === void 0 ? void 0 : _seoPostcode$split[0]
                  })
                });
              }

              return feature;
            })
          }));

        case 42:
        case "end":
          return _context7.stop();
      }
    }, _callee6, null, [[26, 35, 38, 41]]);
  })));

  _defineProperty(this, "reverseAddressActions", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
    var endpoint,
        _ref15,
        type,
        resource,
        _ref15$payload,
        payload,
        signal,
        res,
        _args8 = arguments;

    return _regeneratorRuntime.wrap(function _callee7$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          endpoint = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : _this.endpoints.address;
          _ref15 = _args8.length > 1 ? _args8[1] : undefined, type = _ref15.type, resource = _ref15.resource, _ref15$payload = _ref15.payload, payload = _ref15$payload === void 0 ? {} : _ref15$payload, signal = _ref15.signal;
          _context8.next = 4;
          return runQueryInit(endpoint, _this.httpOptions)(type, resource, payload, null, null, signal);

        case 4:
          res = _context8.sent;
          return _context8.abrupt("return", {
            data: get(res, 'data.features', [])
          });

        case 6:
        case "end":
          return _context8.stop();
      }
    }, _callee7);
  })));

  _defineProperty(this, "algoliaSearchActions", function (query) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _this.endpoints.algolia.search(query, options === null || options === void 0 ? void 0 : options.isDemo);
  });

  this.endpoints = endpoints;

  var agent = httpOptions.agent,
      crudHttpOptions = _objectWithoutProperties(httpOptions, _excluded2);

  var encryptionService;

  if (EncryptionModule && storage) {
    encryptionService = new EncryptionService(storage, EncryptionModule);
  } else {
    encryptionService = storage ? new EncryptionService(storage) : null;
  }

  this.runQueryCrud = runQueryInit(this.endpoints.api, crudHttpOptions, encryptionService);
  this.runQueryAuth = runQueryInit(this.endpoints.auth, {}, encryptionService);
  this.httpOptions = httpOptions;
});

export { Rest as default };
//# sourceMappingURL=index.js.map